import * as React from 'react';
const SvgNo = (props) => (
  <svg
    width="19"
    height="18"
    viewBox="0 0 19 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.5 1.5H3.25C2.85218 1.5 2.47064 1.65804 2.18934 1.93934C1.90804 2.22064 1.75 2.60218 1.75 3V8.25C1.75 8.64782 1.90804 9.02936 2.18934 9.31066C2.47064 9.59196 2.85218 9.75 3.25 9.75H5.5M10.75 11.25V14.25C10.75 14.8467 10.5129 15.419 10.091 15.841C9.66903 16.2629 9.09674 16.5 8.5 16.5L5.5 9.75V1.5H13.96C14.3217 1.49591 14.6728 1.6227 14.9484 1.857C15.2241 2.09129 15.4058 2.41732 15.46 2.775L16.495 9.525C16.5276 9.73998 16.5131 9.95949 16.4525 10.1683C16.3919 10.3771 16.2866 10.5703 16.1439 10.7344C16.0012 10.8984 15.8246 11.0296 15.6262 11.1186C15.4278 11.2076 15.2124 11.2525 14.995 11.25H10.75Z"
      fill="white"
      stroke="currentColor"
      strokeWidth={1.2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgNo;
